 export const Constant = {
  UniCode: {
    rupees: "₹"
  },
};
